import { useQuery } from '@tanstack/react-query';
import { CreditCard, Download, Loader2, Wallet } from 'lucide-react';
import { downloadInvoicePdf, fetchPayments } from '../api/candidate';
import { formatEuro } from '../lib/format';
import dayjs from '../lib/dates';
import PayableInvoices from '../components/PayableInvoices';
import { Button, Card, EmptyState } from '../components/charte';

// Mes paiements (refonte du 14/10/2026) : factures à régler, total réglé, historique — mêmes données.

export default function PaymentsView() {
  const { data, isLoading } = useQuery({ queryKey: ['candidate', 'payments'], queryFn: fetchPayments });

  const payments = data ?? [];
  const total = payments.reduce((acc, p) => acc + p.amount, 0);

  return (
    <div className="grid gap-5 sm:gap-6">
      <div>
        <h1 className="text-title-md text-heading sm:text-title-lg">Mes paiements</h1>
        <p className="mt-1 text-sm text-secondary">Réglez vos factures et consultez l’historique de vos règlements.</p>
      </div>

      <PayableInvoices />

      {payments.length > 0 && (
        <Card className="flex items-center gap-4">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-panel-indigo text-white">
            <Wallet size={22} aria-hidden />
          </span>
          <div>
            <p className="text-eyebrow uppercase text-muted">Total réglé</p>
            <p className="text-title-md text-heading">{formatEuro(total)}</p>
          </div>
          <p className="ml-auto hidden text-sm text-secondary sm:block">
            {payments.length} règlement{payments.length > 1 ? 's' : ''}
          </p>
        </Card>
      )}

      <Card>
        <h2 className="text-title-sm text-heading">Historique</h2>
        {isLoading ? (
          <p className="mt-4 flex items-center text-sm text-secondary">
            <Loader2 className="mr-2 animate-spin" size={16} /> Chargement…
          </p>
        ) : payments.length === 0 ? (
          <EmptyState className="mt-4" icon={CreditCard} title="Aucun paiement" description="Aucun paiement enregistré pour le moment." />
        ) : (
          <ul className="mt-4 divide-y divide-slate-100">
            {payments.map((p) => (
              <li key={p.id} className="flex flex-wrap items-center gap-x-3 gap-y-2 py-3.5 first:pt-0 last:pb-0">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-surface-2 text-secondary">
                  <CreditCard size={17} aria-hidden />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-heading">{p.label}</p>
                  <p className="text-xs text-secondary">
                    {dayjs(p.date).format('DD/MM/YYYY')} · {p.type}
                  </p>
                </div>
                <p className="shrink-0 text-sm font-semibold text-heading">{formatEuro(p.amount)}</p>
                {p.invoiceId && (
                  <Button
                    size="sm"
                    icon={Download}
                    title="Télécharger la facture"
                    onClick={() => downloadInvoicePdf(p.invoiceId as string, p.label.replace(/^Facture\s+/i, ''))}
                  >
                    Facture
                  </Button>
                )}
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
